import { render, staticRenderFns } from "./DelPrivilege.vue?vue&type=template&id=35b02632&scoped=true"
import script from "./DelPrivilege.vue?vue&type=script&lang=js"
export * from "./DelPrivilege.vue?vue&type=script&lang=js"
import style0 from "./DelPrivilege.vue?vue&type=style&index=0&id=35b02632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b02632",
  null
  
)

export default component.exports